import { render } from "./CodeHighlighter2.vue?vue&type=template&id=00cab4c6"
import script from "./CodeHighlighter2.vue?vue&type=script&lang=ts"
export * from "./CodeHighlighter2.vue?vue&type=script&lang=ts"
script.render = render

export default script